export const MEDIAS_FEATURE_KEY = 'medias';
